import Industries from './Industries'
import * as actions from './industries-actions'
import * as constants from './industries-constants'
import reducer from './industries-reducer'
import saga from './industries-saga'
import * as selectors from './industries-selectors'

export {Industries, actions, constants, reducer, saga, selectors}
export default Industries
